import axios, { AxiosRequestConfig } from "axios";
import { getToken } from "./jwt";

export const BASE_URL = "https://api.intranetsonrie.site"; // https://api.intranetsonrie.site & https://api.intranetsonrie.site

const api = axios.create({
  baseURL: `${BASE_URL}/api`,
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export async function request<T>(
  url: string,
  options?: AxiosRequestConfig
): Promise<T> {
  try {
    const response = await api.request<T>({ url, ...options });
    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      const message = error.response?.data?.message || error.message;
      throw new Error(message || "Ocurrió un error inesperado");
    }
    if (error instanceof Error) {
      throw new Error(error.message || "Ocurrió un error inesperado");
    }
    throw new Error("Ocurrió un error inesperado");
  }
}

export default api;
